export const ORDER_STATUS_CREATED = 1;
export const ORDER_STATUS_WAITING_FOR_PAYMENT_IN_STORE = 200;
